import { render, staticRenderFns } from "./ModalCreateAttendancePerMonth.vue?vue&type=template&id=56bfcc0b&"
import script from "./ModalCreateAttendancePerMonth.vue?vue&type=script&lang=js&"
export * from "./ModalCreateAttendancePerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports